const formatDistanceLocale = {
  xMinute: '1 m',
  xMinutes: '{{count}} m',
  xSeconds: '< 1 m'
};

const customLocale = {
  formatDistance: (token, count, options) => {
    switch (token) {
      case 'aboutXHours':
        return count === 1 ? 'an hour' : count;

      case 'xMinutes':
        if (options) {
          return count > 1 ? formatDistanceLocale.xMinutes.replace('{{count}}', count) : formatDistanceLocale.xMinute;
        }
        break;

      case 'lessThanXMinutes':
      case 'lessThanXSeconds':
      case 'xSeconds':
        if (options) {
          return formatDistanceLocale.xSeconds;
        }
        break;
    }

    return count < 10 ? 0 + (count ? count.toString() : '0') : count;
  }
};

export default customLocale;
